import React from 'react';
import PageFrame from './PageFrame';
import PageToolbar from './PageToolbar';
import StatCardRow from './StatCard';
import resolveTemplateHeader, { mergeFamilyHeaderChrome } from './resolveTemplateHeader';
import { ShellChromeProvider } from './ShellChromeContext';

/**
 * AnalyticalListPageTemplate — Fiori Analytical List Page.
 * Header → optional status → section nav → toolbar → KPIs → filters → content.
 * Table panels typically use ListReportTemplate inside `content`.
 */
const AnalyticalListPageTemplate = ({
  children,
  className = '',
  dir,
  wide = true,
  header,
  familyHeader,
  title,
  subtitle,
  headerActions,
  status,
  sectionNav,
  toolbar,
  contextFilters,
  embedFiltersInToolbar = true,
  stats,
  statsClassName = '',
  filters,
  content,
}) => {
  const inlineToolbarFilters =
    contextFilters ??
    (embedFiltersInToolbar !== false && familyHeader ? filters : undefined);
  const mergedFamilyHeader = mergeFamilyHeaderChrome(familyHeader, {
    toolbar,
    filters: inlineToolbarFilters,
  });
  const resolvedHeader = resolveTemplateHeader({
    header,
    familyHeader: mergedFamilyHeader,
    title,
    subtitle,
    headerActions,
  });

  return (
    <ShellChromeProvider titleOwned={Boolean(familyHeader)}>
      <PageFrame
        className={['ads-screen-analytical', 'ads-screen-list', className].filter(Boolean).join(' ')}
        dir={dir}
        wide={wide}
      >
        {resolvedHeader}
        {status || null}
        {sectionNav ? (
          <div className="ads-screen-analytical__section-nav">{sectionNav}</div>
        ) : null}
        {toolbar && !familyHeader ? <PageToolbar>{toolbar}</PageToolbar> : null}
        {stats ? (
          <StatCardRow className={statsClassName}>{stats}</StatCardRow>
        ) : null}
        {filters && (!familyHeader || contextFilters != null || embedFiltersInToolbar === false) ? (
          <div className="ads-screen-list__filters">{filters}</div>
        ) : null}
        {content ?? children}
      </PageFrame>
    </ShellChromeProvider>
  );
};

export default AnalyticalListPageTemplate;
